import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import MenuContent from "../../components/layout-components/MenuContent";
import { DIR_LTR, DIR_RTL, NAV_TYPE_SIDE } from "../../constants/ThemeConstant";
import { connect, useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { onDirectionChange, onLocaleChange } from "redux/actions/Theme";
import { MenuOutlined } from '@ant-design/icons';
import MobileMenu from "./MobileMenu";
import { getLogo, getStoreData, setCart, getPromotionBanners, setCategoryNavClicked, getPinnedBox } from "redux/actions";
import { getAttachment } from "utils/attachment";
import { localStorageCart, setLocalStorageCart } from "utils/cart";
import { isOpenByTime } from "utils/estimated";
import LinksPopup from "./linksPopup";

export const AppViews = (props) => {
    const { fetchedData: { logo, storeData, timings }, cartData: { cartQuantity, navClicked, cart }, theme: { locale } } = useSelector(state => state)
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const history = useHistory();
    const [linksPopupVisible, setLinksPopupVisible] = useState(false);

    function getTotalQuantity() {
        setLocalStorageCart();
        return localStorageCart?.reduce((acc, cur) => acc + cur.quantity, 0);
    }

    useEffect(() => {
        dispatch(getLogo());
        dispatch(getPromotionBanners(''));
        dispatch(getStoreData());
        dispatch(getPinnedBox(''));
    }, []);

    useEffect(() => {
        dispatch(setCart(getTotalQuantity()));
    }, [localStorage.getItem('cart')]);

    useEffect(() => {
        // set default language
        props.onLocaleChange(storeData?.defaultLang==='ENGLISH'?'en':'ar')
        props.onDirectionChange(storeData?.defaultLang==='ENGLISH'?DIR_LTR:DIR_RTL)

        // set title
        document.title = locale === 'en' ? storeData.nameEng : storeData.nameAr

        //setting logo in title bar
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = logo?.attachment?.id ? getAttachment(logo?.attachment?.id) : "/img/productsFallback.svg";

        // top bar color
        const themeColor = document.querySelector("meta[name='theme-color']")
        themeColor.content = storeData?.primaryColor ?? '#000'
        
    }, [storeData]);

    const [menuOpen, setMenuOpen] = useState(false)

    function changeLang() {
        if (props.direction === DIR_LTR) {
            props.onDirectionChange(DIR_RTL)
            props.onLocaleChange('ar')
            localStorage.setItem('lang', 'ar')
            localStorage.setItem('dir', 'rtl')
            document.title = storeData.nameAr
        } else {
            document.title = storeData.nameEng
            props.onDirectionChange(DIR_LTR)
            props.onLocaleChange('en')
            localStorage.setItem('lang', 'en')
            localStorage.setItem('dir', 'ltr')
        }
    }

    const navbar = document.querySelector('.nav-fixed');
    const sideNav = document.querySelector('.ant-layout-sider');
    const sections = document.querySelectorAll(".scrolling-category-block");
    const navLi = document.querySelectorAll(".menu-tabs .menu-tab");
    const el = document.querySelector('.menu-tabs')

    if (window.innerWidth < 992) {
        if (navClicked?.element) {
            sections.forEach((e, index) => {
                if (navClicked.index === index) {
                    window.scrollTo(0, e.offsetTop + 30);
                    dispatch(setCategoryNavClicked({element: '', index: ''}))
                }
            })
        }
        window.onscroll = () => {
            if (window.scrollY > 15 && pathname === '/app/menu') {
                navbar?.classList.add('navBar');
            } else {
                navbar?.classList.remove('navBar');
            }
            if (navClicked?.element) {
                return
            } else {
                var current = "";
                sections.forEach(section => {
                    const sectionTop = section.offsetTop;
                    if (window.pageYOffset - 24 >= sectionTop) {
                        current = section.getAttribute("id");
                    } else if (sections[0].offsetTop > window.pageYOffset - 24) {
                        current = sections[0].getAttribute("id");
                    }
                });
                navLi.forEach((li) => {
                    li.classList.remove("active");
                    if (li.id === current) {
                        li.classList.add("active");
                        el.scrollLeft = li.offsetLeft;
                    }
                });
            }
        };
    } else {
        if (navClicked?.element) {
            sections.forEach((e, index) => {
                if (navClicked.index === index) {
                    sideNav.scrollTop = e.offsetTop - 80;
                    dispatch(setCategoryNavClicked({element: '', index: ''}))
                }
            })
        } else {
            sideNav?.addEventListener('scroll', () => {
                var current = "";
                 sections.forEach((section) => {
                    const sectionTop = section.offsetTop;
                    if (sideNav.scrollTop + 80 >= sectionTop) {
                        current = section.getAttribute("id");
                    } else if (sections[0].offsetTop > sideNav.scrollTop + 80) {
                        current = sections[0].getAttribute("id");
                    }
                });
                navLi.forEach((li) => {
                    li.classList.remove("active");
                    if (li.id === current) {
                        li.classList.add("active");
                        el.scrollLeft = li.offsetLeft;
                    }
                });
            })
        }
    }

    useEffect(() => {
        if (menuOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'initial';
    }, [menuOpen])

    useEffect(() => {
        document.documentElement.style.setProperty('--primaryColor', storeData?.primaryColor);
        document.documentElement.style.setProperty('--primaryDarkColor', storeData?.primaryDarkColor);
    }, [storeData])

    const reviewCard = () => {
        if ((localStorage.getItem('selected-mode') !== null && localStorage.getItem('fulfillment-time') !== null) || cartQuantity === 0) {
            history.push('review-cart');
        } else {
            history.push(`order-mode?mode=${storeData?.showDeliveryText ? 'delivery' : 'pickup'}`);
            localStorage.setItem('location', 'review-cart');
        }
    }

    return (
        <div style={{ height: '40%'}}>
            {storeData?.homePopup?.status && <LinksPopup linksPopupVisible={linksPopupVisible} setLinksPopupVisible={setLinksPopupVisible}/>}
            {menuOpen && <MobileMenu setMenuOpen={setMenuOpen} setLinksPopupVisible={setLinksPopupVisible} />}
            <div className="d-flex justify-content-between nav-fixed ">
                <Button size="small" shape="circle" className="menuButton" onClick={() => setMenuOpen(true)}>
                    <MenuOutlined style={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }} />
                </Button>
                <MenuContent
                    type={NAV_TYPE_SIDE}
                    {...props}
                />
                <div className="d-flex rightButtons">
                    {storeData?.enableDelivery && isOpenByTime(timings) && <div>
                        <div onClick={reviewCard} className={`d-flex align-items-center justify-content-center cursor-pointer ${cartQuantity > 0 ? 'cartButtonWithNumber ' : 'cartButton'}`}>
                            <img src="/img/cart.svg" alt="Cart" style={{ width: '20px', height: '20px' }} />
                            {cartQuantity > 0 && <span className="font- text-black">{cartQuantity}</span>}
                        </div>
                    </div>}
                    <Button size="small" shape="circle" className="d-flex align-items-center justify-content-center" onClick={changeLang}>
                        <div style={{ fontSize: '16px', color: 'black', position: 'relative' }}>
                            {props.direction === DIR_RTL ? "EN" : <span style={{ fontWeight: 'bold' }}>ﻉ</span>}
                        </div>
                    </Button>
                </div>
            </div>
            <div className="logoDiv">
                <img src={logo?.attachment?.id ? getAttachment(logo?.attachment?.id) : "/img/productsFallback.svg"} alt="image" style={{ width: '150px', height: '150px' }} /><br />
                <h1>{locale === 'en' ? storeData.nameEng : storeData.nameAr}</h1>
            </div>
        </div>
    )
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed, sideNavTheme, direction } = theme;
    return { navCollapsed, sideNavTheme, direction }
};

const mapDispatchToProps = {
    onDirectionChange,
    onLocaleChange,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppViews);